import { Navigate } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectPulse = () => {
  const { navigation } = useNavigation()

  return <Navigate to={navigation.engagement.pulse.participation.fullPath()} />
}

export default RedirectPulse
